<template>
    <div class="sustainable-component admin-department">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa avdelning" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="DepartmentName"
                                                                  id="DepartmentName"
                                                                  type="text"
                                                                  label="Avdelningsnamn"
                                                                  variant="outlined"
                                                                  v-model="department.DepartmentName"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-btn variant="tonal" @click="createDepartment" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{departments.length}} avdelningar</b>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Avdelning</th>
                            <th class="col-2">Adress</th>
                            <th class="col-2">Postnr</th>
                            <th class="col-2">Ort</th>
                            <th class="col-2">Telefon</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in departments" :key="index">
                            <td>{{item.DepartmentName}}</td>
                            <td>{{item.Address}}</td>
                            <td>{{item.ZipCode}}</td>
                            <td>{{item.City}}</td>
                            <td>{{item.Telephone}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateDepartment(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteDepartment(item.DepartmentId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateDepartment ref="updateDepartmentModal" @updated="loadDepartments"></UpdateDepartment>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateDepartment from './update/update-department.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateDepartmentModal = ref(null);

    export default {

        name: 'admin-department',
        props: {

        },
        components: {
            UpdateDepartment,
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async createDepartment() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await AdminService.createDepartment(this.department);
                    this.displaySnackBar("Avdelningen lades till");
                    this.loadDepartments();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async loadDepartments() {
                this.loading++;
                try {
                    this.departments = await AdminService.getDepartments();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateDepartment(department) {
                this.loading++;
                this.updateDepartmentModal.open(department)
                this.loading--;
            },
            async deleteDepartment(departmentId) {
                if (confirm("Är du säker att du vill radera avdelningen?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteDepartment(departmentId);
                        this.displaySnackBar("Avdelningen togs bort");
                        this.loadDepartments();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                department: {
                    Name:''
                },
                departments: [],
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {

        },
        mounted() {
            this.loadDepartments();
        },
        setup() {
            return { form, updateDepartmentModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>